import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useMoneyProcessingStore = defineStore('moneyProcessing', () => {
  const isMoneyTopUpIndicatorVisible = ref(false)
  const processingAmount = ref<string | null>(null)
  const processingCurrency = ref<string | null>(null)

  const showMoneyTopUpIndicator = (amount: string, currency: string) => {
    processingAmount.value = amount
    processingCurrency.value = currency
    isMoneyTopUpIndicatorVisible.value = true
  }

  const hideMoneyTopUpIndicator = () => {
    isMoneyTopUpIndicatorVisible.value = false
    processingAmount.value = null
    processingCurrency.value = null
  }

  return {
    isMoneyTopUpIndicatorVisible,
    processingAmount,
    processingCurrency,
    showMoneyTopUpIndicator,
    hideMoneyTopUpIndicator
  }
})
